<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Fecha"
          label-for="fecha"
          :labelCols="labelCols"
          :description="descripcion">
          <b-input-group>
            <b-form-input 
              id="fecha" 
              v-model="fecha" 
              type="date"
              :state="fechaValida">
            </b-form-input>
          </b-input-group>
          <b-form-invalid-feedback id="fechaFeedback">
            {{ fechaInvalidaMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Aceptar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import moment from 'moment';

export default {
  name: 'SeleccionFecha',
  components: {
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  props: {
    fechaInicial: {
      type: String,
      default: ''
    },
    descripcion: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      fecha: moment(new Date()).format('YYYY-MM-DD'),

      noValidar: true,
      fechaValida: null,
      fechaInvalidaMsj: '',

      labelCols: 2,
    }
  },
  created() {
    if (this.fechaInicial != '') {
      this.fecha = moment(this.fechaInicial).format('YYYY-MM-DD');
    }
  },  
  methods: {
    save () {
      let save = Boolean(true);

      if (save) {
        this.$emit('fechaSeleccionada', this.fecha);
      }
    },
    cancelar() {
      this.$emit('seleccionFechaCancelada');
    },
  },
  watch: {
  }    
}
</script>

<style>
</style>
